import React, { useState } from "react";
import "./Footer.css";

const socialIcons = [
  {
    name: "Facebook",
    icon: (
      <svg width="20" height="20" fill="currentColor">
        <path d="M18 0h-16c-1.1 0-2 0.9-2 2v16c0 1.1 0.9 2 2 2h8.6v-7h-2.2v-2.6h2.2v-2c0-2.1 1.3-3.3 3.2-3.3 0.9 0 1.8 0.1 2 0.1v2.3h-1.3c-1.1 0-1.3 0.6-1.3 1.2v1.7h2.7l-0.3 2.6h-2.4v7h4.7c1.1 0 2-0.9 2-2v-16c0-1.1-0.9-2-2-2z" />
      </svg>
    ),
    href: "#",
  },
  {
    name: "Twitter",
    icon: (
      <svg width="20" height="20" fill="currentColor">
        <path d="M20 3.8c-0.8 0.4-1.7 0.7-2.6 0.8 0.9-0.5 1.6-1.4 1.9-2.3-0.9 0.5-1.7 0.9-2.7 1.1-0.8-0.9-2-1.5-3.1-1.5-2.4 0-4.1 2.1-3.6 4.4-3.1-0.1-5.9-1.7-7.7-4.2-0.3 0.6-0.5 1.4-0.5 2.1 0 1.5 0.8 2.9 2 3.7-0.7 0-1.4-0.2-2-0.5 0 0 0 0.1 0 0.2 0 2.1 1.4 3.9 3.4 4.3-0.3 0.1-0.7 0.2-1 0.2-0.2 0-0.5 0-0.7-0.1 0.5 1.6 2.1 2.8 4.1 2.8-1.5 1.2-3.2 1.9-5.2 1.9-0.3 0-0.7 0-1-0.1 1.8 1.2 3.9 1.9 6.2 1.9 7.4 0 11.5-6.1 11.5-11.5 0-0.2 0-0.4 0-0.5 0.8-0.6 1.5-1.3 2-2.1z"/>
      </svg>
    ),
    href: "#",
  },
  {
    name: "LinkedIn",
    icon: (
      <svg width="20" height="20" fill="currentColor">
        <path d="M18.7 0h-17.4c-0.7 0-1.3 0.6-1.3 1.3v17.4c0 0.7 0.6 1.3 1.3 1.3h17.4c0.7 0 1.3-0.6 1.3-1.3v-17.4c0-0.7-0.6-1.3-1.3-1.3zM6.1 17h-2.7v-8.7h2.7v8.7zM4.8 7.3c-0.8 0-1.5-0.7-1.5-1.5s0.7-1.5 1.5-1.5 1.5 0.7 1.5 1.5c0 0.9-0.7 1.5-1.5 1.5zM17 17h-2.7v-4.3c0-1-0.4-1.6-1.3-1.6-0.8 0-1.2 0.6-1.2 1.6v4.2h-2.7v-8.7h2.6v1.1c0.4-0.8 1.3-1.6 2.7-1.6 2 0 3 1.3 3 3.7l0 5.5z"/>
      </svg>
    ),
    href: "#",
  },
  {
    name: "Instagram",
    icon: (
      <svg width="20" height="20" fill="currentColor">
        <path d="M10 4.6c-2.9 0-5.4 2.4-5.4 5.4s2.4 5.4 5.4 5.4 5.4-2.4 5.4-5.4-2.4-5.4-5.4-5.4zM10 13.5c-2 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zM16.7 4.3c0 0.5-0.4 0.9-0.9 0.9s-0.9-0.4-0.9-0.9 0.4-0.9 0.9-0.9 0.9 0.4 0.9 0.9zM18 5.2c-0.1-0.7-0.2-1.3-0.7-1.8-0.4-0.5-1.1-0.6-1.8-0.7-0.7-0.1-2.6-0.1-5.5-0.1s-4.8 0-5.5 0.1c-0.7 0.1-1.4 0.2-1.8 0.7-0.5 0.4-0.6 1.1-0.7 1.8-0.1 0.7-0.1 2.6-0.1 5.5s0 4.8 0.1 5.5c0.1 0.7 0.2 1.3 0.7 1.8 0.4 0.5 1.1 0.6 1.8 0.7 0.7 0.1 2.6 0.1 5.5 0.1s4.8 0 5.5-0.1c0.7-0.1 1.3-0.2 1.8-0.7 0.5-0.4 0.6-1.1 0.7-1.8 0.1-0.7 0.1-2.6 0.1-5.5s-0.1-4.8-0.1-5.5zM16.6 16.6c-0.2 0.5-0.6 1-1.1 1.1-0.8 0.3-2.7 0.2-5.5 0.2s-4.7 0.1-5.5-0.2c-0.5-0.2-1-0.6-1.1-1.1-0.3-0.8-0.2-2.7-0.2-5.5s-0.1-4.7 0.2-5.5c0.2-0.5 0.6-1 1.1-1.1 0.8-0.3 2.7-0.2 5.5-0.2s4.7-0.1 5.5 0.2c0.5 0.2 1 0.6 1.1 1.1 0.3 0.8 0.2 2.7 0.2 5.5s0.1 4.7-0.2 5.5z"/>
      </svg>
    ),
    href: "#",
  },
];

const footerLinks = {
  platform: [
    { name: "ATS Resume Builder", href: "#ats" },
    { name: "College Campus to Job", href: "#interview" },
    { name: "Courses", href: "#courses" },
    { name: "1-1 Mock Interviews", href: "#hackathons" },
    { name: "Codeverse", href: "#placement" },
  ],
  company: [
    { name: "About Us", href: "#about" },
    { name: "Careers", href: "#careers" },
    { name: "Blog", href: "https://skillonblog.netlify.app/" },
    { name: "Press", href: "#press" },
    { name: "Contact", href: "#contact" },
  ],
  support: [
    { name: "Help Center", href: "#help" },
    { name: "Community", href: "#community" },
    { name: "Privacy Policy", href: "#privacy" },
    { name: "Terms of Service", href: "#terms" },
    { name: "Cookie Policy", href: "#cookies" },
  ],
};

const Footer = () => {
  const [hoveredSocial, setHoveredSocial] = useState(null);

  return (
    <footer className="footer">
      <div className="footer-background">
        <div className="footer-shapes">
          <div className="footer-shape"></div>
          <div className="footer-shape"></div>
          <div className="footer-shape"></div>
        </div>
      </div>
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="brand-logo"><span className="logo-text">Company Name</span></div>
            <p className="brand-description">
              Empowering careers through innovative technology. Join thousands
              of professionals who have transformed their career journey with our comprehensive platform.
            </p>
            <div className="contact-info">
              <div className="contact-item"><span>✉️</span> <span>support@xyz.com</span></div>
              <div className="contact-item"><span>📞</span> <span>+0 (000) 00-0000</span></div>
              <div className="contact-item"><span>📍</span> <span>San Francisco, CA 94105</span></div>
            </div>
          </div>
          <div className="footer-links">
            {Object.entries(footerLinks).map(([section, links]) => (
              <div className="link-column" key={section}>
                <h4>{section.charAt(0).toUpperCase() + section.slice(1)}</h4>
                <ul>
                  {links.map((link, i) => (
                    <li className="small-text" key={i}><a href={link.href}>{link.name}</a></li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <div className="footer-newsletter">
            <h4>Stay Updated</h4>
            <p>Get the latest career tips, platform updates, and exclusive offers.</p>
            <div className="newsletter-form">
              <input type="email" placeholder="Enter your email" className="newsletter-input"/>
              <button className="newsletter-btn">Subscribe</button>
            </div>
            <div className="social-links">
              {socialIcons.map((social, idx) => (
                <a
                  key={social.name}
                  href={social.href}
                  className={`social-link${hoveredSocial === idx ? " social-hovered" : ""}`}
                  onMouseEnter={() => setHoveredSocial(idx)}
                  onMouseLeave={() => setHoveredSocial(null)}
                >
                  <span className={`social-icon${hoveredSocial === idx ? " hide" : ""}`}>
                    {social.icon}
                  </span>
                  <span className={`social-text${hoveredSocial === idx ? " show" : ""}`}>
                    {social.name}
                  </span>
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; 2025 CareerPro. All rights reserved.</p>
            <div className="footer-bottom-links">
              <a href="#privacy">Privacy</a>
              <a href="#terms">Terms</a>
              <a href="#cookies">Cookies</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
